














import editForm from '@/activeForms/wiki/editNode'
import Vue from 'vue'
import _ from 'lodash'
import wikiNodeModel from '@/models/wiki/wikiNode'
export default Vue.extend({
  props: {
    id: String
  },
  data () {
    return {
      data: {},
      editForm
    }
  },
  methods: {
    onCreated () {
      this.$message({
        // @ts-ignore
        message: this.$t('wiki.node_changed'),
        type: 'success'
      });
      this.loadNode()
    },
    onError () {
      // @ts-ignore
      this.$message({
        // @ts-ignore
        message: this.$t('labels.error'), type: 'error'});
    },
    async loadNode () {
      await this.$store.dispatch('wiki/getNode', this.id)
      this.setData();
    },
    setData () {
      this.data = _.cloneDeep(this.wikiNode.getData())
    },
  },
  computed: {
    wikiNode (): wikiNodeModel {
      return this.$store.state.wiki.nodes[this.id]
    }
  },
  async mounted () {
    await this.loadNode()
  }
})
